// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  text-align: center;
  display: flex;
  background-color: #282c34;
  color: white;
  position: absolute;
  top: 0; bottom: 0; right: 0; left: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,MAAM,EAAE,SAAS,EAAE,QAAQ,EAAE,OAAO;AACtC","sourcesContent":[".main {\n  text-align: center;\n  display: flex;\n  background-color: #282c34;\n  color: white;\n  position: absolute;\n  top: 0; bottom: 0; right: 0; left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
